export const SHOW_MESSAGE = 'common/SHOW_MESSAGE';
export const DISMISS_MESSAGE = 'common/DISMISS_MESSAGE';
